import { useTenantContext } from '../tenant-context';

export const useIsAnonymous = (): boolean => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.isAnonymous;
};
